import React from 'react'

const PostReg: React.FC = () => {
  return (
    <>
    </>
  )
}

export default PostReg